module.exports = __webpack_public_path__ + "static/img/video.5c02d28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/video.png
// module id = 642
// module chunks = 2